import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import en from '../locales/en.json';
import es from '../locales/es.json';
const resources = {
    en: {
        translation: en,
    },
    es: {
        translation: es,
    },
};
// Detect language from localStorage or browser
const getInitialLanguage = () => {
    const savedLanguage = localStorage.getItem('language');
    if (savedLanguage && ['en', 'es'].includes(savedLanguage)) {
        return savedLanguage;
    }
    const browserLanguage = navigator.language.split('-')[0];
    return ['en', 'es'].includes(browserLanguage) ? browserLanguage : 'en';
};
i18n
    .use(initReactI18next)
    .init({
    resources,
    lng: getInitialLanguage(),
    fallbackLng: 'en',
    debug: process.env.NODE_ENV === 'development',
    interpolation: {
        escapeValue: false, // React already escapes values
    },
    react: {
        useSuspense: false, // Disable suspense to avoid loading issues
    },
});
// Save language changes to localStorage
i18n.on('languageChanged', (lng) => {
    localStorage.setItem('language', lng);
});
export default i18n;
